import { OnboardingApplicationStepAndFieldStatus } from "consts/onboarding";
import type { WithFieldsStatuses, WithStatus } from "features/onboarding/types";

export const useStepStatus = () => {
    const getStepStatus = ({ fieldsStatuses }: Partial<WithFieldsStatuses>, totalStepFields: number) => {
        const statuses = Object.values(fieldsStatuses ?? {});

        if (statuses.includes(OnboardingApplicationStepAndFieldStatus.Rejected)) {
            return OnboardingApplicationStepAndFieldStatus.Rejected;
        }

        if (statuses.includes(OnboardingApplicationStepAndFieldStatus.RequestedChanges)) {
            return OnboardingApplicationStepAndFieldStatus.RequestedChanges;
        }

        if (
            Object.is(statuses.length, totalStepFields) &&
            statuses.every(status => Object.is(status, OnboardingApplicationStepAndFieldStatus.Approved))
        ) {
            return OnboardingApplicationStepAndFieldStatus.Approved;
        }

        return OnboardingApplicationStepAndFieldStatus.AwaitingReview;
    };

    const getNestedStepStatus = (entities: WithStatus<OnboardingApplicationStepAndFieldStatus>[]) => {
        const statuses = entities.map(({ status }) => status);

        if (statuses.includes(OnboardingApplicationStepAndFieldStatus.Rejected)) {
            return OnboardingApplicationStepAndFieldStatus.Rejected;
        }

        if (statuses.every(status => Object.is(status, OnboardingApplicationStepAndFieldStatus.Approved))) {
            return OnboardingApplicationStepAndFieldStatus.Approved;
        }

        if (statuses.includes(OnboardingApplicationStepAndFieldStatus.RequestedChanges)) {
            return OnboardingApplicationStepAndFieldStatus.RequestedChanges;
        }

        return OnboardingApplicationStepAndFieldStatus.AwaitingReview;
    };

    return {
        getStepStatus,
        getNestedStepStatus
    };
};

export default useStepStatus;
